import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { simpleFetch } from '../utils/http';
import { SearchPaneResultsContext } from '../contexts';
import { SelectedUsersContext, EditUserContext } from '../../pages/UserPage/context';
import { flattenAttributes } from './Header/components/utils';

const UIDLink = ({ uid, comma }) => {
  const [userData, setUserData] = useState({ name: '', data: {} });
  const { setEditUser } = useContext(EditUserContext);
  const { setSortedSearchResults } = useContext(SearchPaneResultsContext);
  const { setSelectedUsers } = useContext(SelectedUsersContext);
  useEffect(() => {
    const fetchUser = async () => {
      if (uid) {
        try {
          const data = await simpleFetch(`/api/v1/people/${uid}`);
          const name = flattenAttributes(data).find(attribute => attribute.name === 'name').attributes[0].value;
          setUserData({ name, data });
        } catch (e) {
          console.error(
            'UID Link - While fetching user:',
            uid,
            ', received error:',
            e
          );
        }
      } else {
        setUserData({});
      }
    };
    fetchUser();
  }, [uid]);
  return (
    <a
      href="/"
      onClick={event => {
        event.preventDefault();
        setEditUser(false);
        setSortedSearchResults([userData.data]);
        setSelectedUsers([uid]);
      }}
    >
      {userData.name}
      {comma ? ', ' : ''}
    </a>
  );
};
UIDLink.propTypes = { uid: PropTypes.number.isRequired, comma: PropTypes.bool };
UIDLink.defaultProps = { comma: false };

export default UIDLink;
